import { Component, OnInit, OnDestroy, TemplateRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { AppConfig } from '../../app.config';
import { Subscription } from 'rxjs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { TranslationKeys } from 'ph-bhp-localization';
import { PHBHPFeaturePackageObserveObservationService } from '../ph-bhp-feature-package-observe-observation.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-start-observe-observation',
  templateUrl: './start-observe-observation.component.html',
  styleUrls: ['./start-observe-observation.component.css']
})
export class StartObserveObservationComponent implements OnInit, OnDestroy {
  selectedInstitution;
  InstitutionsList: any = [];
  subscription: Subscription;
  subscriptionInstitution: Subscription;
  modalRef: BsModalRef;
  @ViewChild('template') template: TemplateRef<any>;
  selected: number = null
  mygroup = new UntypedFormGroup({
    selectedIns: new UntypedFormControl(this.selected)
  });
  translationKeys: typeof TranslationKeys = TranslationKeys;
  packageIdSubscription: Subscription;
  canShowQuota: boolean = true;
  showTabs: boolean = true;

  constructor(public appConfig: AppConfig,
    public layoutService: PHBHPLayoutPackageService,
    private service: PHBHPListApiService,
    private modalService: BsModalService,
    private observeObservationService: PHBHPFeaturePackageObserveObservationService,
    private router: Router) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        this.updateTabsVisibility(event.urlAfterRedirects);
      });
     }

  ngOnInit() {
    // this.checkForPendingSessionToBeEnded();
    if (this.appConfig.institutions) {
      this.selected = this.layoutService.institutionID;
      this.getInstitutionsbyId()
    } else {
      this.subscription = this.appConfig.userSubject.asObservable().subscribe((res) => {
        this.selected = this.layoutService.institutionID;
        this.getInstitutionsbyId()
      })
    }

    this.subscriptionInstitution = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.selected = this.layoutService.institutionID;
      var institution = this.InstitutionsList.find(x => x.institution.institutionID === this.layoutService.institutionID);
      this.selectedInstitution = institution.institution.institutionName;
    })
  }

  updateTabsVisibility(url: string) {
    this.showTabs = !url.includes('/observe/newquota') && !url.includes('/observe/editquota');
  }

  /**
   * Ends session if observe session data is found is local storage (which means F5 was pressed during observation session and data was preserved)
   */
  private checkForPendingSessionToBeEnded() {
    let observeSessionDataDataItem = localStorage.getItem('observeSessionData');
    var observeSessionData = observeSessionDataDataItem ? JSON.parse(observeSessionDataDataItem) : null
    if (observeSessionData && observeSessionData.observationSessionID) {
      this.observeObservationService.updateSession(observeSessionData, observeSessionData.observationSessionID).subscribe((res: any) => {
        localStorage.removeItem('observeSessionData')
      })
    }
  }

  onInstitutionChange(id) {
    this.layoutService.institutionID = id;
    this.layoutService.institutionIDSubject.next(id);
    this.selectedInstitution = this.InstitutionsList.find(x => x.institution.institutionID === id).institution.institutionName;
  }

  showInstitutionDropDown() {
    if (this.InstitutionsList) {
      if (this.InstitutionsList.length < 2) {
        return false;
      } else {
        return true;
      }
    }
  }

  getInstitutionsbyId() {
    var roleId = this.appConfig.userData.roleName.roleId;
    this.service.getInstitutionsbyId(this.appConfig.institutions, roleId).subscribe((res: any) => {
      this.InstitutionsList = res;
      if (this.layoutService.institutionID)
        this.selectedInstitution = this.InstitutionsList.find(x => x?.institution?.institutionID === this.layoutService.institutionID)?.institution?.institutionName;
    });
  }

  getInstitutionName() {
    if (this.InstitutionsList) {
      return this.InstitutionsList[0].institution.institutionName;
    }
  }

  openmodal(template: TemplateRef<any>) {
    this.mygroup.patchValue({
      selectedIns: this.selected
    })
    this.modalRef = this.modalService.show(template, Object.assign({}, { class: 'w-420' }));
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscriptionInstitution)
      this.subscriptionInstitution.unsubscribe();
  }

  packageDetails() {
    const packageID = this.layoutService.packageID;
    if (packageID && this.layoutService.isObserveLicense(packageID)) {
      this.canShowQuota = true;
    } else {
      this.canShowQuota = false;
      if (this.router.url === '/observe/managequota') {
        this.router.navigate(['/observe']);
      }
    }
  }
}
